module.exports = __webpack_public_path__ + "static/media/play-intro.ca260955.mp3";